import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import '../../../Static/Master/firmtable.css';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSingleQuotation } from '../../../Store/PHPSlice/Sale/Quotation';
import PrintIcon from '@mui/icons-material/Print';
import PreviewIcon from '@mui/icons-material/Preview';
import DescriptionIcon from '@mui/icons-material/Description';
import EditIcon from '@mui/icons-material/Edit';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import { Button } from '@mui/material';

const TableBody = ({
    serialNumber,
    id,
    quotNo,
    dt,
    partyNm,
    firmNm,
    schoolNm,
    itemNm,
    itemId,
    m1,
    retailerId,
    retailerNm,
    sts,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();


    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/ClothEdit/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };
    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("Are you sure you want to delete this Quotation?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            dispatch(deleteSingleQuotation(id))
                .then(() => {
                    // Reload the page to show updated results
                    toast.success("Quotation Deleted Sucessfully");
                    window.location.reload();
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting Item:", error);
                    toast.error("Failed to delete Item");
                });
        }
    };

    const handleViewClick = () => {
        window.open(`/QuotationInfo/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };


    const handleMaterialViewClick = () => {
        window.open(`/quotation-material-viewEntry/${id}/${itemId}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };

    const handlePatternViewClick=()=>{
                window.open(`/quotation-job-viewEntry/${id}/${itemId}/${0}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');

    }
    const handleQuotationPrice = () => {
        // window.open(`/QuotPrint/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
        window.open(`/scr-to-mil-quot/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };

    const handleMiltoPartyPrice = () => {
        window.open(`/mil-to-party-quot/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };


    const handleRetailerPrice = () => {
        window.open(`/retailer-quot/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };
    const handleDiscountPercentage=()=>{
                window.open(`/qtDiscountPer/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');

    }

    const handleMrpPrice = () => {
        window.open(`/mrp-quot/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };

    const handleRateChange = () => {
        window.open(`/RateChange/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };

    const handleRateAnalysis = () => {
        window.open(`/RateAnalysis/${id}`, '_blank');
    };

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {serialNumber}
                </TableCell>

                {/* scr to mil */}
                {/* <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PrintIcon onClick={handleQuotationPrice} className='cursor-pointer' />
                </TableCell> */}

                {/* mil to party */}
                {/* <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PrintIcon onClick={handleMiltoPartyPrice} className='cursor-pointer' />
                </TableCell> */}

                

                {/* Retailer PRice */}
                {/* <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PrintIcon onClick={handleRetailerPrice} className='cursor-pointer' />
                </TableCell> */}

                {/* MRP PRice */}
                {/* <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PrintIcon onClick={handleMrpPrice} className='cursor-pointer' />
                </TableCell> */}
                   {/* discount Percentage */}
                {/* <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <EditIcon onClick={handleDiscountPercentage} className='cursor-pointer' />
                </TableCell> */}

                {/* Info */}
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PreviewIcon onClick={handleViewClick} className='cursor-pointer' />
                </TableCell>

                {/* material View */}
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {/* <PreviewIcon onClick={handleMaterialViewClick} className='cursor-pointer' /> */}
                    <Button variant='contained' color='success' size='small' onClick={handleMaterialViewClick} >Material</Button>
                </TableCell>
                    {/* pattern View */}
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {/* <PreviewIcon onClick={handleMaterialViewClick} className='cursor-pointer' /> */}
                    <Button variant='contained' color='warning' size='small' onClick={handlePatternViewClick} >Job Rate</Button>
                </TableCell>


                {/* <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <DescriptionIcon className='cursor-pointer' />
                </TableCell> */}

                {/* <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <EditIcon onClick={handleRateChange} className='cursor-pointer' />
                </TableCell> */}
                {/* analysis */}
                {/* <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <QueryStatsIcon onClick={handleRateAnalysis} className='cursor-pointer' />
                </TableCell> */}

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {dt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {quotNo}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {firmNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {partyNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {retailerNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {schoolNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {itemNm}
                </TableCell>



                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`} onClick={handleDeleteClick} />
                </TableCell>


            </TableRow>
        </>
    );
};

export default React.memo(TableBody);
